module.exports = __webpack_public_path__ + "static/img/self.8f50ab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/self.png
// module id = JniN
// module chunks = 1 3